import { memo } from 'react';

import { type WorkspaceInfo } from '@air/api/types';
import { ImgixImage } from '@air/component-imgix-image';

export type ContentCollectionWorkspaceInformationProps = {
  workspace: Pick<WorkspaceInfo, 'name' | 'image'>;
};

export const ContentCollectionWorkspaceInformation = memo(
  ({ workspace }: ContentCollectionWorkspaceInformationProps) => {
    return (
      <div className="flex items-center gap-2" data-testid="CONTENT_COLLECTION_WORKSPACE_INFORMATION">
        <div className="relative size-8 overflow-hidden rounded-4 ads:bg-subtle bg-gray-3">
          <ImgixImage
            alt={`Logo for ${workspace.name}`}
            className="size-full object-cover"
            sizes="64px"
            src={workspace.image}
          />
        </div>
        <span
          className="truncate font-medium ads:text-secondary text-14 text-gray-11"
          data-testid="CONTENT_COLLECTION_WORKSPACE_INFORMATION_NAME"
        >
          {workspace.name}
        </span>
      </div>
    );
  },
);

ContentCollectionWorkspaceInformation.displayName = 'ContentCollectionWorkspaceInformation';
